export type ParcelHighlightFilter = [
  'in',
  ['get', 'robust_id'],
  ['literal', string[]],
]

export function buildParcelHighlightFilter(
  robustIds: string | string[] | null,
): ParcelHighlightFilter {
  const ids =
    robustIds === null ? [] : Array.isArray(robustIds) ? robustIds : [robustIds]
  return ['in', ['get', 'robust_id'], ['literal', ids.length > 0 ? ids : ['__none__']]]
}

export const PARCEL_FULL_DETAIL_MIN_ZOOM = 15
export const PARCEL_MIN_VISIBLE_ACRES = 10

export type ParcelFilterExpression = unknown[]

export function buildParcelRevealFilter(): ParcelFilterExpression {
  return [
    'any',
    ['>=', ['zoom'], PARCEL_FULL_DETAIL_MIN_ZOOM],
    ['!', ['has', 'pacres']],
    ['>=', ['get', 'pacres'], PARCEL_MIN_VISIBLE_ACRES],
  ]
}

export function buildParcelBaseLineFilter(
  suppressedRobustIds: string[],
): ParcelFilterExpression {
  if (suppressedRobustIds.length === 0) return buildParcelRevealFilter()
  return [
    'all',
    buildParcelRevealFilter(),
    ['!', ['in', ['get', 'robust_id'], ['literal', suppressedRobustIds]]],
  ]
}

export function buildParcelHitFilter(
  ownedRobustIds: string[],
): ParcelFilterExpression {
  if (ownedRobustIds.length === 0) return buildParcelRevealFilter()
  return [
    'any',
    buildParcelRevealFilter(),
    ['in', ['get', 'robust_id'], ['literal', ownedRobustIds]],
  ]
}
